import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ContentInEvidenceBackgrounds = Record<string, string>

export type EvidenceInitiative = {
  id: string
  description: string
  startdate: string
  enddate: string
  brands: string[]
  cmskey: string
  salesorgs: string[]
  products: { upc: string; model: string }[]
  enabled: boolean
  image?: string
  initiativecode: string
}

type InitiativesState = {
  initiatives: EvidenceInitiative[]
  launchInitiative: boolean
  selectedInitiative: string
  categoryIsLoading: boolean
}

const DEFAULT_STATE: InitiativesState = {
  initiatives: [],
  launchInitiative: false,
  selectedInitiative: '',
  categoryIsLoading: false,
}

export const slice = createSlice({
  name: 'initiatives',
  initialState: DEFAULT_STATE,
  reducers: {
    setInitiatives: (state, { payload }: PayloadAction<{ initiatives: EvidenceInitiative[] }>) => {
      state.initiatives = payload.initiatives
    },
    setSelectedInitiative: (state, { payload }: PayloadAction<string>) => {
      state.selectedInitiative = payload
    },
    setCategoryIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.categoryIsLoading = payload
    },
    setLaunchInitiative: (state, { payload }: PayloadAction<boolean>) => {
      state.launchInitiative = payload
    },
  },
})

export default slice.reducer
